import { View } from 'react-native';
import {
  Checkbox as RNPCheckBox,
  RadioButton as RNPRadioButton,
} from 'react-native-paper';

import colors from 'config/colors';

import Text from './Text';

interface Props {
  value?: any;
  isChecked: boolean;
  onPress: (currentValue: Props['value']) => void;
  isDisabled?: boolean;
  children?: React.ReactNode;
}

export const Checkbox = (props: Props) => {
  const { isChecked, onPress, isDisabled, children } = props;
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
      <RNPCheckBox.Android
        status={isChecked ? 'checked' : 'unchecked'}
        onPress={() => onPress(!isChecked)}
        color={colors.main}
        disabled={isDisabled}
      />
      <Text style={{ opacity: isDisabled ? 0.25 : 1, flexShrink: 1 }}>
        {children}
      </Text>
    </View>
  );
};

export const RadioButton = (props: Props) => {
  const { value, onPress, isDisabled, isChecked } = props;

  return (
    <RNPRadioButton.Android
      value={value}
      status={isChecked ? 'checked' : 'unchecked'}
      onPress={() => onPress(value)}
      color={colors.main}
      disabled={isDisabled}
    />
  );
};
